import React, { Suspense, lazy } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Style from "../../../assets/scss/custom.module.scss";
import { commonText, reffPartner } from "../../../locales/en";
import LoginAsUser from "../../../components/loginasuser/LoginAsUser";

const PartnerManagment = lazy(() => import("../PartnerManagment"));
const MonthlyReport = lazy(() => import("../MonthlyReport"));
const MonthlyCommReport = lazy(
  () => import("../monthly-com-report/MonthlyCommReport")
);

const Refferaltabs = () => (
  <>
    <LoginAsUser />
    <div className={`${Style.tabContainerCustom} tabcontainercustom`}>
      <Tabs
        defaultActiveKey="Partner_Management"
        className="mb-3"
        mountOnEnter
        unmountOnExit={false}
      >
        <Tab eventKey="Partner_Management" title={reffPartner?.title1}>
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <PartnerManagment />
          </Suspense>
        </Tab>
        <Tab eventKey="Monthly_Reporting" title={reffPartner?.title3}>
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <MonthlyReport />
          </Suspense>
        </Tab>
        <Tab eventKey="Monthly_Commison_Report" title={reffPartner?.title4}>
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <MonthlyCommReport />
          </Suspense>
        </Tab>
      </Tabs>
    </div>
  </>
);

export default Refferaltabs;
